import React from 'react';
import styled from '@emotion/styled';
import { N50A, N60A } from '@atlaskit/theme/colors';
import { dialogWidth, dialogPageTakeoverWidth, grid } from '../style-utils';
import { gridSize } from '@atlaskit/theme/constants';
import { N30 } from '@atlaskit/theme/colors';
const SIDEBAR_PANE_WIDTH = gridSize() * 34;
const resultContainerVerticalPadding = gridSize();

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SearchDialogWrapper = styled.div`
	position: relative;
	width: ${dialogWidth};
	box-shadow: ${`var(--ds-shadow-overlay, ${'0 ' + grid.multiple(0.5).px + ' ' + grid.px + ' ' + N50A + ', 0 0 1px ' + N60A})`};
	border-radius: 3px;
	background-color: ${"var(--ds-surface-overlay, #fff)"};
	overflow: hidden;
	margin-top: ${grid.px};
	:focus {
		outline: none;
	}
	display: flex;
	flex-direction: column;
	height: 100%;

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		max-width: 100%;
		border-radius: 0;
		margin-top: 0;
		flex: 1;
		overflow: auto;
	}
`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ResultContainerOuter = styled.div({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  maxWidth: '100%',
  boxSizing: 'border-box'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ResultContainer = styled.div({
  overflowX: 'hidden',
  overflowY: 'auto',
  flex: 1,
  maxWidth: '100%',
  boxSizing: 'border-box'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SidebarScrollContainer = styled.div({
  flex: '1 1 auto',
  overflowX: 'hidden',
  padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`
});

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SidebarContainerPane = styled.div`
	flex: 0 1 auto;
	width: ${SIDEBAR_PANE_WIDTH}px;
	display: flex;
	flex-direction: column;
	max-height: 100%;
	padding-bottom: ${"var(--ds-space-200, 16px)"};

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		display: none;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SidebarContainerBorder = styled.div({
  margin: `${"var(--ds-space-200, 16px)"} 0`,
  borderLeft: `1px solid ${`var(--ds-border, ${N30})`}`
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SidebarBottomFixedContainer = styled.div({
  padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-200, 16px)"}`,
  flex: '0 0 auto'
});
export const SidebarContainer = ({
  children
}) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SidebarContainerBorder, null), /*#__PURE__*/React.createElement(SidebarContainerPane, null, /*#__PURE__*/React.createElement(SidebarScrollContainer, null, children)));
const totalDialogHeightPx = 776 + resultContainerVerticalPadding * 2;
const footerHeight = gridSize() * 6;
const belowDialogSpace = gridSize() * 28;
const aiFullDialogPromptHeight = 64;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const SearchDialogContent = styled.div`
	display: flex;
	max-height: ${props => `calc(100vh - ${belowDialogSpace - footerHeight + (props.aiSearchFullDialogEnabled ? aiFullDialogPromptHeight : 0)}px)`};
	box-sizing: border-box;
	flex: 1;
	min-height: ${props => props.minHeight ? `${props.minHeight}px` : 'auto'};

	@media screen and (min-height: ${totalDialogHeightPx + belowDialogSpace}px) {
		max-height: ${props => `${totalDialogHeightPx - footerHeight - (props.aiSearchFullDialogEnabled ? aiFullDialogPromptHeight : 0)}px;`};
	}

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		max-height: initial;
		overflow: auto;
	}
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export const ResultRenderWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: ${props => props.shouldFixMinimumHeight ? `${props.minimumHeight}px` : 'auto'};

	@media screen and (max-width: ${dialogPageTakeoverWidth}px) {
		flex-grow: 1;
	}
`;